import { render, staticRenderFns } from "./ActivityMissionPage.vue?vue&type=template&id=38cf047c"
import script from "./ActivityMissionPage.vue?vue&type=script&lang=js"
export * from "./ActivityMissionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsSkeletonLoader: require('/app/components/Commons/SkeletonLoader.vue').default,Theme2MissionMobileVipTierCard: require('/app/components/Theme2/Mission/Mobile/VipTierCard.vue').default,Theme2MissionDesktopExpiredDateTime: require('/app/components/Theme2/Mission/Desktop/ExpiredDateTime.vue').default,Theme2MissionDesktopRoadmapLayoutsTypeGuideline: require('/app/components/Theme2/Mission/Desktop/Roadmap/Layouts/TypeGuideline.vue').default,Theme2MissionMobileRoadmapLayoutsTypeOne: require('/app/components/Theme2/Mission/Mobile/Roadmap/Layouts/TypeOne.vue').default,Theme2MissionDesktopRoadmapLayoutsTypeTwo: require('/app/components/Theme2/Mission/Desktop/Roadmap/Layouts/TypeTwo.vue').default,Theme2MissionMobileRoadmapLayoutsTypeThree: require('/app/components/Theme2/Mission/Mobile/Roadmap/Layouts/TypeThree.vue').default,Theme2MissionTermAndConditionDialog: require('/app/components/Theme2/Mission/TermAndConditionDialog.vue').default,Theme2MissionClaimActivitySuccessDialog: require('/app/components/Theme2/Mission/ClaimActivitySuccessDialog.vue').default})
